import axios from 'axios';
import { ADMIN_PATH } from './companySession';
import {
  COMPANY_CONTEXT_LOST,
  clearStoredAccessToken,
  forceLogoutRedirect,
  getStoredAccessToken,
  refreshAccessToken,
} from './authToken';

const REFRESH_PATH = process.env.REACT_APP_REFRESH_PATH || '/refresh';

const isRefreshRequest = (config) => {
  const url = config?.url ?? '';
  return url.includes('/refresh') || url.endsWith(REFRESH_PATH);
};

const api = axios.create({
  baseURL: process.env.BASE_URL,
  withCredentials: true,
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = getStoredAccessToken();
    const existingAuth = config.headers?.Authorization ?? config.headers?.authorization;
    if (token && !existingAuth) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !isRefreshRequest(originalRequest)
    ) {
      originalRequest._retry = true;

      try {
        const newAccessToken = await refreshAccessToken();
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        if (refreshError?.code === COMPANY_CONTEXT_LOST) {
          window.location.replace(ADMIN_PATH);
          return Promise.reject(refreshError);
        }
        clearStoredAccessToken();
        forceLogoutRedirect();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
